<template>
  <div class="copyright">
    <div class="common-box tryout-box" v-if="$route.meta.showUse">
      <div class="tryout">
        <p >手机办公无时无刻，随时随地，自由自在</p>
        <div >
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <img
              src="../assets/decorate/btn-shadow.png"
              alt
              class="shadow-cion"
              v-if="showBoxShadow"
            />
          </transition>
          <button
            class="point"
            @mouseenter="enter"
            @mouseleave="showBoxShadow= false"
            @click="setDotted()"
          >免费试用</button>
        </div>
        <img src="../assets/decorate/5.png" alt class="suqare" />
        <img src="../assets/decorate/4.png" alt class="circle" />
      </div>
    </div>
    <div class="common-box about-box">
      <div class="about">
        <div class="about-info" >
          <p class="about-title">产品介绍</p>
          <div class="about-label point about-hover" @click="goOutSide(1)">关于蓝凌</div>
          <!-- <div class="about-label point about-hover" @click="goOutSide(2)">联系我们</div> -->
          <div class="about-label point about-hover" @click="goOutSide(3)">产品介绍</div>
        </div>
        <div class="about-info ">
          <p class="about-title">新手指南</p>
          <div class="about-label point about-hover" @click="goHelp(0)">如何试用</div>
          <div class="about-label point about-hover" @click="goHelp(1)">如何购买</div>
          <div class="about-label point about-hover" @click="goHelp(2)">如何登录</div>
        </div>
        <div class="about-info ">
          <p class="about-title">常见问题</p>
          <div class="about-label tel"><div>4006-222-312</div></div>
          <div class="about-label name">深圳市蓝凌软件股份有限公司</div>
          <div class="about-label address">深圳市南山区深南大道9966号威盛科技大厦10楼</div>
        </div>
      </div>
    </div>
    <div class="common-box copy " ><span>版权所有 © 2001-2020 <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备17015126号</a></span> <img src="../assets/govIcon.gif" alt=""></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBoxShadow: false
    };
  },
  mounted() {
  },
  methods: {
    enter() {
      this.showBoxShadow = true;
    },
    setDotted() {
      _czc.push(["_trackEvent","底部_免费试用", "button"]);
      console.log('czc',_czc)
      // this.$router.push("/scancode");
      this.$root.$emit('change',true)
    },
    goHelp(type) {
      switch (type) {
        case  0 :
            // window.open("https://faq.dingteam.com/docs/mindoc/on-trial"); 
            this.$root.$emit('change',true)

        break;  
        case  1 :
            window.open("https://faq.dingteam.com/docs/mindoc/buy");  
        break;  
        case  2 :
            window.open("https://faq.dingteam.com/docs/mindoc/register");  
        break;  
      }
    },
    goOutSide(type) {
      switch (type) {
          case  1 :
            window.open("https://www.landray.com.cn");    
          break;
            case  2 :
            window.open("http://www.landray.com.cn/lanling_c/");  
          break;
            case  3 :
            this.$router.push('/product') ;
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
// .copyright{
//   position:fixed;
//   bottom:0;
//   width:100%;
// }
.copy {
  font-size: 14px;
  color: #999999;
  height: 100px;
  background: #f2f2f2;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;

  img{
    width: 10px;
    height:14px;
    margin-left: 10px;
  }
}
.tryout-box {
  background: #fafbfc;
}
.tryout {
  font-size: 16px;
  text-align: center;
  line-height: 12px;
  text-shadow: 0 2px 17px rgba(255, 255, 255, 0.13);
  width: 1200px;
  height: 320px;
  position: relative;
  > p {
    padding-top: 100px;
    padding-bottom: 52px;
    font-size:26px;
  }
  > div {
    position: relative;
    width: 126px;
    height: 42px;
    margin: 0 auto;
  }
  button {
    background-image: linear-gradient(-36deg, #b8f1ff 0%, #186fff 100%);
    border-radius: 21px;
    color: #ffffff;
    border: none;
    width: 100%;
    line-height: 42px;
    position: relative;
    font-size:16px;
    outline:none;
    :focus {outline:none;} 
    ::-moz-focus-inner {border-color: transparent;} 
  }
  .circle {
    position: absolute;
    left: 0;
    top: 0;
    width: 320px;
  }
  .suqare {
    position: absolute;
    right: 50px;
    bottom: 0;
    width: 200px;
  }
}
.about-box {
  background: url("../assets/map.png") top right no-repeat;
  background-size: auto 426px;
  font-weight: normal;
}
.about {
  padding-left: 120px;
  padding-top: 120px;
  background-size: 750px;
  height: 426px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
     .about-hover {
       font-weight:300;
       &:hover{
         color:#4285f4;
       }
      }
  .about-info {
    display: inline-block;
    margin-right: 140px;
  }
  .about-title {
    font-size: 16px;
    color: #333333;
    text-align: center;
    line-height: 18px;
    text-align: left;
    margin-bottom: 40px;
  }
  .about-label {
    font-size: 16px;
    color: #999999;
    text-align: center;
    line-height: 16px;
    text-align: left;
    margin-bottom: 20px;
  }
  .tel {
    font-size: 28px;
    color: #4285f4;
    line-height: 28px;
    margin-bottom: 9px;
    font-family: "DAB";
    display: flex;
    align-items: center;
  }
  .name {
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    margin-bottom: 18px;
  }
  .address {
    font-size: 14px;
    color: #999999;
    line-height: 16px;
  }
  .fSize{
    font-size: 24px;
    display: inline-block;
    margin-top: -3px;
  }
}
.shadow-cion {
  position: absolute;
  top: 5px;
  left: -5px;
  width: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/copyRight.vue